<script>
import Layout from "../layouts/main"
import PageHeader from "@/components/page-header";
import {
  GetDataMethods,
  PostDataMethods
} from "@/state/helpers";
/**
 * Orders Component
 */
export default {
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Companies",
      items: [
        {
          text: "Wesal Units"
        },
      ],
      serviceData: [],
      services: null,
      newCommission: 0,
      data: {
        balance: 0,
      },
      fields: [
        { key: "services_category.name", label: "Company Category" },
        { key: "name", label: "Name Service" },
        { key: "balance", label: "Balance" },
        { key: "commission", label: "Commission" },
        { key: "updated_at", sortable: false, label: "Updated At" },
        { key: "id", sortable: false, label: "Action" }
      ],
    }
  },

  mounted() {
    this.getDataa()
  },

  methods: {
    ...GetDataMethods,
    ...PostDataMethods,

    async getDataa() {
      this.getData("get_service_with_categories").then((res) => {
        this.serviceData = res.data.data.services;
      })
    },

    OnInput(id, val) {
      this.$refs["my-modal"].show();
      this.id = id;
      this.data.balance = val;
      return;
    },

    hendlerCancel() {
      this.$refs["my-modal"].hide();
      this.getDataa();
    },


    async updateCommission() {
      if (this.services) {
        this.putData({ key: "update_commission_company/ " + this.services.id + " ?commission=" + this.newCommission })
          .then((res) => {
            if (res.status == 200) {
              this.$refs["commission-modal"].hide();
              this.makeToast('success', 'Success', res.data.message)
              this.getDataa();
            } else if (res.status == 400) {
              this.$refs["commission-modal"].hide();
              this.makeToast('danger', 'Fial', res.data.message)
            } else if (res.status == 500) {
              this.$refs["commission-modal"].hide();
              this.makeToast('danger', 'Fial', res.data.message)
            }
          });
      }
    },

    async openPointsModal(services) {
      this.services = services;
      this.$refs["commission-modal"].show();
    },

    async makeToast(variant = null, body = null, title = null) {
      this.$bvToast.toast(title, {
        title: `${body}`,
        variant: variant,
        solid: true,
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body pt-0">


            <div class="table-responsive">
              <b-table striped hover bordered class="table-centered" show-empty empty-text="No records found"
                :items="serviceData" :fields="fields" responsive="sm">

                <template v-slot:cell(updated_at)="data">
                  <div>{{ data.value | formatDate }}</div>
                </template>
                <template v-slot:cell(created_at)="data">
                  <div>{{ data.value | formatDate }}</div>
                </template>
                <template v-slot:cell(id)="data">
                  <router-link :to="{ name: 'balance', params: { id: data.value } }"
                    class="mdi mdi-plus mr-2 font-size-18" v-b-tooltip.hover title="Add">
                  </router-link>

                  <a class="mdi mdi-pencil mr-2 font-size-18" v-b-tooltip.hover title="Edit commission"
                    @click="openPointsModal(data.item)"></a>

                </template>
              </b-table>
            </div>


            <!-- <b-modal ref="my-modal" size="sm" hide-footer no-close-on-backdrop id="modal-backdrop" title="Edit"
                  title-class="font-18">
                  <p>Are you sure Update this Balance ?</p>
                  <b-button class="mt-2 mr-2" variant="outline-danger">OK</b-button>
                  <b-button class="mt-2" variant="outline-primary" @click="hendlerCancel">Cancel</b-button>
                </b-modal> -->

            <!-- Start Model Withdrawal of points -->
            <b-modal ref="commission-modal" title="New Commission" hide-footer>
              <div>
                <label for="newPoints">Commission:</label>
                <b-form-input v-model="newCommission" type="number" min="0"></b-form-input>
              </div>
              <b-button class="mt-3" variant="primary" @click="updateCommission">Save</b-button>
              <b-button class="mt-3 ml-2" variant="secondary"
                @click="$refs['commission-modal'].hide()">Cancel</b-button>
            </b-modal>
            <!-- End Model -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>